import IconView from "../IconView";
"use strict";

let IframeViewIconView = IconView.createPlugin("iframe", {

    initialize() {
        IframeViewIconView.__super__.initialize.apply(this, arguments);
    },

    onOpen() {
        system.runApp({
            type: "Iframe",
            title: this.model.get("title"),
            src: this.model.get("url")
        });
    }

});

export default IframeViewIconView;
